/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Ascending {
  /**
   * Generate a constantly ascending number
   *
   * @public
   * @function f1.ascending
   * @param seed the initial number to count from
   * @example
   *
   * ```ts
   * f1.ascending() => 1
   * f1.ascending() => 2
   * f1.ascending(6) => 7
   * f1.ascending() => 8
   * ```
   */
  (seed?: number): number;
}

/**
 * the ascending number we will count
 * @ignore
 */
let c = 0;

/**
 * @see Ascending
 */
export default (seed = c) => {
  return (c = seed >= Number.MAX_SAFE_INTEGER ? 0 : seed + 1);
};
